import LegalPage from './LegalPage'
import { COOKIE_POLICY } from './legal'

export default function CookiePolicyPage() {
  return <LegalPage {...COOKIE_POLICY} />
}
